import { Route, Routes } from "react-router-dom";
import ChatModule from ".";

const HelpdeskRoute = () => {
  return (
    <Routes>
      <Route path="/:chatId" element={<ChatModule />} />
      <Route path="/*" element={<ChatModule />} />
    </Routes>
  );
};

export default HelpdeskRoute;
